module.exports = __webpack_public_path__ + "media/Forro.3f3e27ef.mp3";